import { Box } from '@customerio/pluma-components/react';

/** Onboarding usage step. Placeholder — content lands with FPS-2865. */
export function OnboardingUsageStep() {
  return <Box data-testid="signup-step-onboarding-usage" />;
}
